import {useEffect, useState} from "react";
import axios from "axios";
import { APIURL, AUTH_CREDENTIALS_NAME } from "../Constantes";
const useApi = (url="") =>{
    const getCabecera = () =>{
        let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
        let cabecera = { Authorization: `bearer ${Token}`,
        "Content-Type": "application/json",
        Accept: "application/json",}
        return cabecera;
    }
    const [data, setData] = useState([]);
    useEffect(() =>{
        const getAPI = async () =>{
            try {
                const response = await axios.get(`${APIURL}/${url}`,
                {
                    headers: getCabecera()
                });
                switch (response.status) {
                    case 200:
                        setData(response.data)
                        break;
                    default:
                        setData([]);
                        break;
                }
            } catch (error) {
                setData([]);
            }
        }
        getAPI();
        return () =>{
            setData([]);
        }
    },[url])
    return data;
}
export default useApi;